import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "components/Common/Breadcrumb";
import DataTable from "../../components/Common/LocalizedDataTable";
import { PriceRangeSlabApi } from "apis/priceRangeSlab";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import config from "config/config";
import Swal from "../../helpers/swal_helper";
import { set } from "lodash";
import { formatNumber } from "../../helpers/language_helper";

function PriceRangeSlabList(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [activeData, setActiveData] = useState({
    page: 1,
    totalPage: 1,
    search: "",
    limit: config.LIMIT,
    status: null,
  });

  useEffect(() => {
    getAllPriceRangeSlabs(activeData);
  }, []);

  let searchTimeout = null;

  const handleSearchChange = (e) => {
    const value = e.target.value;
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      const updated = { ...activeData, search: value, page: 1 };
      setActiveData(updated);
      getAllPriceRangeSlabs(updated);
    }, 300);
  };

  const columns = [
    {
      name: props.t("Sr.No"),
      selector: (row) => row.id,
      cell: (row) => formatNumber(row.id),
      sortable: true,
    },
    {
      name: props.t("Slab Name"),
      selector: (row) => row.slab_name,
      sortable: true,
    },
    {
      name: props.t("Min Price"),
      selector: (row) => row.min_price,
      sortable: true,
    },
    {
      name: props.t("Max Price"),
      selector: (row) => row.max_price,
      sortable: true,
    },
    {
      name: props.t("Symbol"),
      selector: (row) => row.symbol || "-",
      sortable: true,
    },
    {
      name: props.t("Status"),
      selector: (row) => (row.status ? props.t("Active") : props.t("Inactive")),
      sortable: true,
      cell: (row) => (
        <span
          style={{
            color: row.status ? "#28a745" : "#dc3545",
            fontWeight: "500",
          }}
        >
          {row.status ? props.t("Active") : props.t("Inactive")}
        </span>
      ),
    },
    {
      name: props.t("Action"),
      selector: (row) => row.action,
    },
  ];

  const getAllPriceRangeSlabs = (data) => {
    setLoading(true);
    PriceRangeSlabApi.fetchPriceRangeSlabs(data)
      .then((res) => {
        if (res.data.status) {
          setActiveData({
            ...activeData,
            totalPage: res.data.pagination.total,
          });
          let tableData = [];
          res.data.data.forEach((v, i) => {
            tableData[i] = {
              id: i + 1,
              slab_name: v.slab_name,
              symbol: v.symbol,
              min_price: v.min_price,
              max_price: v.max_price,
              status: v.status,
              action: (
                <>
                  <Link
                    style={{ marginRight: "15px" }}
                    to={`/edit-price-range-slab/${v.id}`}
                  >
                    <i className="fas fa-edit" id="edittooltip" />
                  </Link>
                  {/* <i
                    className="mdi mdi-delete font-size-18"
                    style={{ color: "red" }}
                    id="deletetooltip"
                    onClick={() => onDelete(v.id)}
                  /> */}
                </>
              ),
            };
          });
          setData(tableData);
        } else {
          Swal.fire({
            title: "Error",
            text: res.data.message,
            icon: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to fetch price range slabs",
          icon: "error",
        });
      });
  };

  const onDelete = (id) => {
    Swal.fire({
      title: props.t("Are you sure?"),
      text: props.t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: props.t("Yes, delete it!"),
      cancelButtonText: props.t("Cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        PriceRangeSlabApi.deletePriceRangeSlab(id)
          .then((res) => {
            if (res.data.status) {
              Swal.fire("Deleted!", res.data.message, "success");
              getAllPriceRangeSlabs(activeData);
            } else {
              Swal.fire("Error!", res.data.message, "error");
            }
          })
          .catch((err) => {
            console.log(err);
            Swal.fire("Error!", "Failed to delete price range slab", "error");
          });
      }
    });
  };

  const handleChange = (page) => {
    const updatedData = { ...activeData, page };
    setActiveData(updatedData);
    getAllPriceRangeSlabs(updatedData);
  };

  const handleRowChange = (limit) => {
    const updatedData = { ...activeData, limit };
    setActiveData(updatedData);
    getAllPriceRangeSlabs(updatedData);
  };

  //meta title
  document.title = props.t("Price Range Slabs") + " | " + props.t("Salon");

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={props.t("Dashboard")}
          breadcrumbItem={props.t("Price Range Slabs")}
        />
        {/* <Link
          to="/add-price-range-slab"
          className="btn btn-primary w-xs btn-right"
        >
          {props.t("Add")}
        </Link> */}
      </div>

      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder={props.t("Search by name")}
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                const updated = {
                  ...activeData,
                  search: e.target.value,
                  page: 1,
                };
                setActiveData(updated);
                getAllPriceRangeSlabs(updated);
              }}
            />
          </div>

          <div className="col-md-3">
            <select
              className="form-control"
              value={selectedStatus}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                const updated = {
                  ...activeData,
                  status: e.target.value === "All" ? null : e.target.value === "true",
                  page: 1,
                };
                setActiveData(updated);
                getAllPriceRangeSlabs(updated);
              }}
            >
              <option value="All">{props.t("All")}</option>
              <option value="true">{props.t("Active")}</option>
              <option value="false">{props.t("Inactive")}</option>
            </select>
          </div>
        </div>

        <DataTable
          className="table-bordered"
          progressPending={loading}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={activeData.totalPage}
          paginationPerPage={activeData.limit}
          defaultSortFieldID={1}
          onChangeRowsPerPage={(value) => handleRowChange(value)}
          onChangePage={(value) => handleChange(value)}
          sortable
          noHeader
          defaultSortField="id"
          defaultSortAsc={false}
          highlightOnHover
        />
      </div>
    </div>
  );
}

PriceRangeSlabList.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(PriceRangeSlabList);
